import { authRef, databaseRef } from 'config'
import { logout } from './logout.action'

export const deleteUser = (
  userId: string,
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  const user = authRef.currentUser
  const updates = {}

  window.localStorage.clear()
  updates[`care_professionals/${userId}`] = null
  updates[`parents/${userId}`] = null
  updates[`users/${userId}`] = null
  databaseRef
    .update(updates)
    .then(async () => {
      if (user) {
        await user.delete()
      }

      logout()(dispatch)
    })
    .then(() => successCallback())
    .catch(error => {
      const { message } = error
      errorCallback(message)
    })
    .catch(error => {
      const { message } = error
      errorCallback(message)
    })
}



// WEBPACK FOOTER //
// ./src/store/user/actions/deleteUser.action.ts